'use strict';

var keyMirror = require('keymirror');

var ActionTypes = keyMirror({
  PROJECT_LOAD: null,
  PROJECT_LOAD_REQUEST: null,
  PROJECT_LOAD_DONE: null,
  PROJECT_LOAD_FAIL: null,

  PAGE_LOAD: null,
  PAGE_LOAD_REQUEST: null,
  PAGE_LOAD_DONE: null,
  PAGE_LOAD_FAIL: null,

  FINISH_OPEN_PAGE: null,

  PAGE_REDIRECT: null,
  PAGE_REDIRECT_REQUEST: null,
  PAGE_REDIRECT_DONE: null,
  PAGE_REDIRECT_FAIL: null,

  CONNECT_NET_FAIL: null,

  LOAD_REVIEW_DATA_REQUEST: null,
  LOAD_REVIEW_DATA_DONE: null,
  LOAD_REVIEW_DATA_FAIL: null,

  ADD_REVIEW_REQUEST: null,
  ADD_REVIEW_DONE: null,
  ADD_REVIEW_FAIL: null,

  ADD_COMMENT_REQUEST: null,
  ADD_COMMENT_DONE: null,
  ADD_COMMENT_FAIL: null,

  LOAD_COMMENT_DATA_REQUEST: null,
  LOAD_COMMENT_DATA_DONE: null,
  LOAD_COMMENT_DATA_FAIL: null,

  UPDATE_REVIEW_REQUEST: null,
  UPDATE_REVIEW_DONE: null,
  UPDATE_REVIEW_FAIL: null,

  REMOVE_REVIEW_REQUEST: null,
  REMOVE_REVIEW_DONE: null,
  REMOVE_REVIEW_FAIL: null,

  ERROR: null,
  CLEAR_ERROR: null,

  LOAD_PROJECT_REVIEWS: null,
  LOAD_PROJECT_REVIEWS_REQUEST: null,
  LOAD_PROJECT_REVIEWS_DONE: null,
  LOAD_PROJECT_REVIEWS_FAIL: null
});

module.exports = ActionTypes;



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js